module.exports = __webpack_public_path__ + "resources/img/img_tcc_advantage5.9457c409446e7930f54ff35a58f8be6a.jpg";